import { z } from "zod";

export const PENDING_SHOPIFY_INTEGRATION_COOKIE =
  "replo_pending_shopify_integration";

export const pendingShopifyIntegrationCookieSchema = z.discriminatedUnion(
  "type",
  [
    z.object({
      type: z.literal("onboarding"),
      projectId: z.string().nullish(),
      workspaceId: z.string().nullish(),
      hostingType: z.enum(["shopify", "replo"]).nullish(),
    }),
    z.object({
      type: z.literal("home"),
      projectId: z.string(),
      workspaceId: z.string(),
    }),
    z.object({
      type: z.literal("sections"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("noShopifyErrorModal"),
      projectId: z.string(),
      workspaceId: z.string(),
    }),
    z.object({
      type: z.literal("projectSettings"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("newProject"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("publish"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("shopStyles"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("preview"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("assets"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("productPicker"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("billingModal"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("shopSettingsIntegration"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("projectView"),
      workspaceId: z.string(),
      projectId: z.string(),
    }),
    z.object({
      type: z.literal("analytics"),
      projectId: z.string(),
      workspaceId: z.string(),
    }),
    z.object({
      type: z.literal("abtesting"),
      projectId: z.string(),
      experimentId: z.string().nullish(),
      workspaceId: z.string().nullish(),
    }),
  ],
);

export type PendingShopifyIntegrationCookie = z.infer<
  typeof pendingShopifyIntegrationCookieSchema
>;

export const REPLO_JWT_COOKIE = "reploJwt";
export const REPLO_INTERNAL_API_JWT_COOKIE = "reploInternalApiJwt";
